<div class="wrapper">
  <!-- Displays the actual content of this component if no html was provided. -->
  <ng-content *ngIf="!showHTML"></ng-content>

  <!-- Displays provided HTML instead of the content. -->
  <span *ngIf="showHTML" [innerHTML]="showHTML"></span>
</div>
